<template>
  <UIDialog :is-open :z-index size="lg" :title flat @close="handleClose">
    <div class="ui-image-cropper-preview" :style="imageStyles" />
  </UIDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ModalClass } from '@types'

import { UIDialog } from '@ui/modals'

type Props = {
  modal: ModalClass<any>
  image: string
  title?: string
  aspectRatio: number
}

const {
  modal,
  image,
  title = 'Image Preview',
  aspectRatio,
} = defineProps<Props>()

const isOpen = computed(() => modal.isOpened)
const zIndex = computed(() => modal.zIndex)

const imageStyles = computed(() => {
  return {
    backgroundImage: `url(${image})`,
    aspectRatio,
  }
})

const handleClose = () => {
  modal.close()
}
</script>

<style>
.ui-image-cropper-preview {
  @apply bg-body-dark bg-cover bg-center bg-no-repeat;
}
</style>
